import _groupBy from 'lodash/fp/groupBy';
import _prop from 'lodash/fp/prop';
import _compose from 'lodash/fp/compose';
import _map from 'lodash/fp/map';
import _dissoc from 'lodash/fp/dissoc';
import _reduce from 'lodash/fp/reduce';
import _times from 'lodash/fp/times';
import _first from 'lodash/fp/first';

const generalConverter = error => ({
	[error.dataPath.slice(1)]: error.message,
	index: 0
});

const additionalConverter = error => ({
	[error.dataPath.replace(/\..*\./, '')]: error.message,
	index: Number(error.dataPath.match(/\d\d*/)) + 1
});

const convertError = error => /additional_postbacks/.test(error.dataPath)
	? additionalConverter(error)
	: generalConverter(error);

const buildErrorArray = item => _first(item)
	? _reduce((acc, error) => ({...acc, ..._dissoc('index', error)}), {})(item)
	: {};

const creatingErrorArray = limit => grouppedErrors => _compose(
	_map(
		_compose(
			buildErrorArray,
			_reduce((acc, idx) => acc.concat(grouppedErrors[idx]), []))
	),
	_times(String)
)(limit);

export default (errors, fieldsLimit = 2) => _compose(
	creatingErrorArray(fieldsLimit),
	_groupBy(_prop('index')),
	_map(convertError)
)(errors);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/global-postback/shared/createArrayFieldErrors.js